import { useEffect, useState } from "react"

import { Divider, Segmented, Typography } from "antd"
import { useSearchParams } from "react-router-dom"

import AlertsTab from "./components/AlertsTab"
import LookupsTab from "./components/LookupsTab"
import { PRICING_TAB } from "./redux/pricing.constants"

import styles from "./styles.module.less"

const PRICING_TAB_OPTIONS = [
  { value: PRICING_TAB.ALERTS, label: "Alerts" },
  { value: PRICING_TAB.LOOKUPS, label: "Lookups" }
]

const PRICING_TAB_COMPONENTS = {
  [PRICING_TAB.ALERTS]: AlertsTab,
  [PRICING_TAB.LOOKUPS]: LookupsTab
}

const { Title } = Typography

const PricingPage = () => {
  const [searchParams] = useSearchParams()
  const [activeTab, setActiveTab] = useState(() => {
    const tab = searchParams.get("tab")
    return Object.values(PRICING_TAB).includes(tab) ? tab : PRICING_TAB.ALERTS
  })

  const ActiveTab = PRICING_TAB_COMPONENTS[activeTab]

  useEffect(() => {
    document.title = "Pricing - Chargeback"
  }, [])

  return (
    <div className={styles.page}>
      <Title level={3} style={{ textAlign: "left", marginBottom: 16 }}>
        Pricing
      </Title>

      <Divider />

      <Segmented
        options={PRICING_TAB_OPTIONS}
        value={activeTab}
        onChange={setActiveTab}
        size="large"
        style={{ marginBottom: 16, fontWeight: 500 }}
      />

      <ActiveTab />
    </div>
  )
}

export default PricingPage
